import { ReactNode } from "react";

import Box from "@mui/material/Box";

interface ITabPanelProperties {
  children: ReactNode;
  currentIndex: number;
  index: number;
}

/**
 * Renders a panel for a specific tab index. It conditionally displays the content based on the
 * current index of the tab selector. The content is wrapped in a Box component.
 *
 * @param  children - JSX to be displayed in the tab panel.
 * @param  index - The index of the panel.
 * @param  currentIndex - The current index of the tab selector.
 */
export default function TabPanel({ children, currentIndex, index }: ITabPanelProperties) {
  return (
    <Box
      aria-labelledby={`simple-tab-${index}`}
      hidden={currentIndex !== index}
      id={`simple-tabpanel-${index}`}
      role="tabpanel"
      sx={{
        borderRadius: 1,
        display: currentIndex === index ? "flex" : "none",
        flexDirection: "column",
        flexGrow: 1,
        height: "100%",
        //  height: "auto", // or remove height property entirely
        minHeight: 0, // this is important to prevent overflow
        zIndex: 0,
      }}
    >
      {currentIndex === index && children}
    </Box>
  );
}
